export const Props = () => ({
  //ID Подкаста
  idPodcast: {
    type: Number,
    required: true,
  },

  //Максимальная высота области видимости
  height: {
    type: Number,
    default: 320,
  },

  //Градиент для 'занавески'
  gradient: {
    type: String,
    default: 'var(--dropdown-scroll-gradient)',
  }
});
